<template>
  <modal ref='deleteProductsModal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('products.delete.title') }} </h5>
    </template>

    <template #body>
      <form class="modal-fix">
        <div class='modal-body'>
          <p> {{ $t('products.delete.body') }} </p>
        </div>

        <div class='modal-footer'>
          <a @click.prevent="closeModal()" class="btn btn-outline-primary float-right" href="">{{ $t('share_invite.close') }}</a>
          <a @click.prevent="deleteProducts" class="btn btn-danger float-right" href=""> {{ $t('products.delete.delete') }} </a>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import _modal from '../_modal'


export default {
  components: {
    'modal': _modal,
  },
  data: function () {
    return {
      product: [],
    }
  },
  methods: {
    open(product) {
      this.product = product
      this.$refs.deleteProductsModal.open()
    },
    closeModal() {
      this.$refs.deleteProductsModal.close()
    },
    deleteProducts(){
      this.store.destroyProduct(this.product).then(() => {
        this.store.sendMetrics({name: 'delete_product', params: this.$route.params, path: this.$route.fullPath})
        this.$emit('success')
        this.$toastr.success(this.$t('products.delete.success'))
        this.closeModal()
      })
    }
  }
}
</script>
